<div id="toast" class="toast-container" [ngClass]="{'toast-show': showToast, 'toast-hide': hideToast}">
    <div class="toast-card"
         [ngClass]="{'alert-success': isSuccess, 'alert-warning': isWarning, 'alert-danger': isError}">
        <h5 class="toast-title" [innerHTML]="title"></h5>
        <p class="toast-message" [innerHTML]="message"></p>
        <div class="toast-close">
            <i class="fas fa-times fa-2x" aria-hidden="true" (click)="onClickClose()"></i>
        </div>
    </div>
</div>